import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';

interface ImagePreviewCellProps {
  src: string;
}

export function ImagePreviewCell({ src }: ImagePreviewCellProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <img
          src={src}
          alt="Preview"
          className="h-[34px] w-auto rounded-lg cursor-pointer hover:opacity-80 transition-opacity"
        />
      </DialogTrigger>
      <DialogContent className="max-w-fit p-2">
        <img src={src} alt="Full preview" className="max-h-[80vh] max-w-[80vw] rounded-lg" />
      </DialogContent>
    </Dialog>
  );
}
